declare global {
  interface Window {
    rg4js: (cmd: string, ...args: unknown[]) => void
  }
}

/**
 * Wrap the raygun client instance to use an "api" similar to the node version
 * see: plugins/raygun.server.js
 */
const raygunClientWrapper = {
  send (...args: unknown[]) {
    window.rg4js('send', ...args)
  }
}

export default raygunClientWrapper
